import React from 'react'
import { useFormContext } from 'react-hook-form'
import TextField from '@material-ui/core/TextField'

// react-hook-form v6 drops natively disabled inputs from submitted and
// validated values, so a locked field shows a disabled input and keeps its
// value in form state through a registered hidden input.
const InviteLockableTextField = ({
  name,
  locked,
  lockedValue,
  defaultValue,
  ...props
}) => {
  const { register } = useFormContext()

  if (!locked) {
    return (
      <TextField
        name={name}
        inputRef={register()}
        defaultValue={defaultValue}
        {...props}
      />
    )
  }

  return (
    <>
      <TextField {...props} value={lockedValue || ''} disabled />
      <input
        type="hidden"
        name={name}
        defaultValue={lockedValue || ''}
        ref={register()}
      />
    </>
  )
}

export default InviteLockableTextField
